// extracted by mini-css-extract-plugin
module.exports = {"form":"Checkout_form__1eTc-","control":"Checkout_control__EWcmx","actions":"Checkout_actions__2QNLN","submit":"Checkout_submit__sON11","invalid":"Checkout_invalid__12bo-"};